import AddActivity from "../../Components/Modals/AddActivity";
import Table from "../../Components/Table";
import {  deleteActivityById, getAllActivityPagination } from "../../Services/MasterService";

const Activity = () => {
    // name, state_id, status, logo, id
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Description",
            value: "description",
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddActivity data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllActivityPagination}
            columns={columns}
            title={"Activity Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteActivityById}
        />
    );
}

export default Activity;